<template>
  <div class="trust">
    <div class="wrap">
      <span class="eyebrow">Trusted by brands big and small</span>
    </div>
    <div class="marquee" aria-label="Brands running Adverpost screens">
      <div class="mq-track">
        <!-- The set is rendered twice so the CSS marquee loops seamlessly. -->
        <div class="mq-set">
          <span v-for="b in brands" :key="b" class="mk">{{ b }}</span>
        </div>
        <div class="mq-set" aria-hidden="true">
          <span v-for="b in brands" :key="'dup-' + b" class="mk">{{ b }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrustMarquee",
  data() {
    return {
      // Real Adverpost clients, ranked by brand size. Wordmarks for now; swap in
      // official logo files supplied by each client (with permission).
      brands: [
        "Nike",
        "McDonald's",
        "Toyota",
        "Subway",
        "Volkswagen",
        "Domino's",
        "Coles",
        "Anytime Fitness",
        "Harvey Norman",
        "Bakers Delight",
        "Ray White",
        "IGA",
        "TerryWhite Chemmart",
        "Total Tools",
        "Walker Corporation",
        "Blooms The Chemist",
        "Adelaide University",
        "OZ Design Furniture",
        "Foodland",
        "Thirsty Camel",
        "Ritchies",
        "Highgrove Bathrooms",
        "CarSwap",
        "Barnacle Bill",
        "Café de Vili's",
        "The Fan and Light Shop",
        "Farquar Kitchens",
        "Trinity College",
        "Adelaide Botanic High School",
        "U-Install-It Kitchens",
        "Uzit Kitchens",
        "Colley Hotel",
      ],
    };
  },
};
</script>
